import { render, staticRenderFns } from "./CategoryBlock.vue?vue&type=template&id=28cf0e8d&"
import script from "./CategoryBlock.vue?vue&type=script&lang=js&"
export * from "./CategoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./CategoryBlock.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CategoryBlock.vue"
export default component.exports